import { OrCardV3 as OrCard } from '@onereach/ui-components';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ContactBooksListHeader',
    components: {
        OrCard,
    },
});
